import React from 'react';

import isArchived from 'archive/isArchived';
import {ActionOrigin} from 'constants/AnalyticsConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import SidepanelItem from 'nav/sidepanel/listing/SidepanelItem';
import {ListableItem} from 'search/SearchConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import fuzzydate from 'util/fuzzydate';

import {ConnectionListingGraphQL} from '../../../../graphql-fragments/instruments/__generated/ConnectionListingGraphQL';
import * as ConnectionContextMenu from './ConnectionContextMenu';

interface ConnectionSidepanelItemProps {
  actionSource?: ActionOrigin;
  isActive: boolean;
  isCompact: boolean;
  connection: ConnectionListingGraphQL;
  openResult: (item: ListableItem) => void;
  isChild: boolean;
}

export default function ConnectionSidepanelItem(props: ConnectionSidepanelItemProps): JSX.Element {
  const {isActive, isCompact, connection, isChild} = props;
  const date = fuzzydate(connection.modifiedAt, {compact: isCompact, showTime: false});
  const subtitle = `${isCompact ? '' : 'Modified '}${date}`;
  const title = connection.name;
  return (
    <SidepanelItem
      active={isActive}
      className="sidepanelItem--noIcon"
      faded={isArchived(connection)}
      icon={<BenchlingIcon icon={ModelTypeConstants.CONNECTION} />}
      isCompact={isCompact}
      onClick={() => {
        props.openResult(connection);
      }}
      parties={[{...connection.creator, avatar_url: connection.creator.avatar_url!}]}
      subTitle={subtitle}
      title={{
        text: title,
        node: <div>{title}</div>,
      }}
      tooltipText=""
      onContextMenu={(e: React.SyntheticEvent) => {
        ConnectionContextMenu.open(e.nativeEvent, connection, {actionSource: props.actionSource});
      }}
      isExpandable={false}
      isChild={isChild}
    />
  );
}
